import Helmet from 'react-helmet';
import styles from './index.module.scss';

const Privacy = () => {
  return (
    <>
      <Helmet title="裝置確認" />
      <div className={styles.privacy}>
        <div>
          <h3>隱私政策隱私政策隱私政策隱私政策隱私政策隱私政策隱私政策隱私政策</h3>
        </div>
      </div>
    </>
  );
};
export default Privacy;
